import { Box, Button, Grid, Input, Stack, TextField, Typography, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { Field, Form } from 'react-final-form'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TextFieldCustom } from '../../components/FormElements';
import { config_path } from '../../router/config.path';
import validators from '../../utils/validators';
import PublicPage from '../PublicPage';
import { CheckIcon, CloseLineIcon, EyeIcon, EyeOffIcon } from '../../components/IconComponent';

export default function CreatePasswordView(props) {
    const { message, validations } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { palette } = useTheme();
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

    return (
        <PublicPage message={message} showProcessing={props.showProcessing} confirm={props.confirm}>
            <Grid item xs={12} marginTop={4}>
                <Typography variant='h4' textAlign={'center'}>{t('create_password')}</Typography>
            </Grid>
            <Grid item xs={12} marginTop={4}>
                <Grid item xs={12}>
                    <Form
                        onSubmit={props.onSubmit}
                        render={({ handleSubmit }) => (
                            <Grid xs={12} container item>
                                {validations && !validations.is_valid && <Box width={'100%'} px={2} py={1} borderRadius={2} backgroundColor={palette.error.light}>
                                    {validations.message && <Typography variant='subtitle2' color={palette.error.main}>{validations.message}</Typography>}
                                    {validations.password_rules && validations.password_rules.length > 0 && <>
                                        <Typography variant='subtitle2' color={palette.error.main}>{t('your_password_need')}</Typography>
                                        {validations.password_rules.map((item, index) => {
                                            let isMatched = validations.parameters.includes(item);
                                            return(
                                                <Stack direction={'row'} alignItems={'center'} spacing={1} key={index}>
                                                    {isMatched ? <CheckIcon /> : <CloseLineIcon color={palette.error.main}/>}
                                                    <Typography variant='subtitle2' color={palette.error.main}>{item}</Typography>
                                                </Stack>
                                            )
                                        })}
                                    </>}
                                </Box>}
                                <Grid item xs={12} marginY={2}>
                                    <Field
                                        name="password"
                                        component={TextFieldCustom}
                                        label={t('password')}
                                        placeholder={t('enter_your_password')}
                                        isEdit={true}
                                        color='default'
                                        validate={validators.composeValidators(validators.required)}
                                        autoFocus={true}
                                        type={showNewPassword ? 'text' : 'password'}
                                        endAdornment={<Box sx={{ cursor: 'pointer' }} onClick={() => setShowNewPassword(!showNewPassword)}>{showNewPassword ? <EyeIcon /> : <EyeOffIcon />}</Box>}
                                    />
                                </Grid>
                                <Grid item xs={12} marginY={2}>
                                    <Field
                                        name="confirm_password"
                                        component={TextFieldCustom}
                                        label={t('confirm_password')}
                                        placeholder={t('enter_confirm_password')}
                                        isEdit={true}
                                        color='default'
                                        validate={validators.composeValidators(validators.required)}
                                        autoFocus={true}
                                        type={showConfirmNewPassword ? 'text' : 'password'}
                                        endAdornment={<Box sx={{ cursor: 'pointer' }} onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)}>{showConfirmNewPassword ? <EyeIcon /> : <EyeOffIcon />}</Box>}
                                    />
                                </Grid>
                                <Grid xs={12} item container marginTop={2}>
                                    <Button variant="contained" fullWidth onClick={handleSubmit}>{t('btn_create_password')}</Button>
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
            </Grid>
        </PublicPage>
    )
}
